export const SETTINGS_IMAGE_MAX_BYTES = 5 * 1024 * 1024
export const SETTINGS_IMAGE_ACCEPT = '.png,.jpg,.jpeg'

const ALLOWED_EXTENSIONS = new Set(['png', 'jpg', 'jpeg'])
const ALLOWED_MIME_TYPES = new Set(['image/png', 'image/jpeg'])

export type SettingsImageValidationError = 'type' | 'size'

export function validateSettingsImage(
  file: Pick<File, 'name' | 'size' | 'type'>
): SettingsImageValidationError | null {
  const extension = file.name.split('.').pop()?.toLowerCase()
  const hasAllowedExtension =
    extension !== undefined && ALLOWED_EXTENSIONS.has(extension)
  const hasAllowedMimeType =
    file.type === '' || ALLOWED_MIME_TYPES.has(file.type.toLowerCase())

  if (!hasAllowedExtension || !hasAllowedMimeType) return 'type'
  if (file.size > SETTINGS_IMAGE_MAX_BYTES) return 'size'

  return null
}
